export enum StickType {
  OpenSection = 'Open Section',
  ClosedSection = 'Closed Section',
  PartialMullion = 'Partial Mullion',
}
